export default __webpack_public_path__ + "static/media/screenshot-05.8d1824db.png";